import MaskedInput, { MaskedInputProps } from "react-text-mask";

export const DateMask = (props: MaskedInputProps & { inputRef(ref: HTMLInputElement | null): void }) => {
    // InputRef: _ has the exact effect as delete props.inputRef;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { id, value, inputRef: _, ...maskedInputProps } = props;

    return (
        <MaskedInput
            guide={false}
            id={id}
            mask={[/\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]}
            placeholder="MM/YYYY"
            placeholderChar={"\u2000"}
            showMask
            value={value}
            {...maskedInputProps} //eslint-disable-line react/jsx-props-no-spreading
        />
    );
};
